import type { GetStaticPaths, GetStaticProps } from 'next'

import { getSiteConfiguration } from '@aether/services/sanity-service'
import { setTag } from '@sentry/nextjs'
import { PageResponse, PageBuilderSection } from '@aether/models'

import { REVALIDATE_COLLECTION, ROUTE_BASE_COLLECTIONS } from '@aether/configs'
import { DefaultPage } from '@aether/page'
import { getCollectionPageProps } from '../../../helpers/getCollectionPageProps'
import { getActiveDiscounts } from '@aether/discounts/data-access'

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export const getStaticProps: GetStaticProps<
  PageResponse<PageBuilderSection[]>
> = async ({ params, locale, preview = false }) => {
  const { slug } = params

  if (Array.isArray(slug)) {
    throw new Error('Product slug must be passed as an string. Received array')
  }

  const collectionPath = `${ROUTE_BASE_COLLECTIONS}/${slug}`

  const [pageProps, siteConfiguration, discounts] = await Promise.all([
    getCollectionPageProps({ slug, locale, isVip: false, preview }),
    getSiteConfiguration(locale, preview),
    getActiveDiscounts(),
  ])

  const isVipCollection = pageProps?.shopifyData?.collection?.vipCollection

  setTag('page_path', collectionPath)
  setTag('page_locale', locale)

  if (!pageProps || isVipCollection) {
    return {
      notFound: true,
      revalidate: REVALIDATE_COLLECTION,
    }
  }

  return {
    props: {
      ...pageProps,
      siteConfiguration,
      allDiscounts: discounts,
    },
    revalidate: REVALIDATE_COLLECTION,
  }
}

export default DefaultPage
